import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function TermsAgreement() {
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [agreeEmail, setAgreeEmail] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!agreeTerms) return;
    localStorage.setItem('acceptedTerms', 'true');
    localStorage.setItem('acceptedSponsoredEmail', agreeEmail ? 'true' : 'false');
    navigate('/create-account');
  };

  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '2rem' }}>
      <h1>Your privacy is our priority</h1>
      <p>
        Our app allows you to access personalized treatment options, genetic and genomic testing
        opportunities, symptom tracking tools integrated into AI, the latest news and clinical trials,
        your medical records, and a peer community. We collect your information to provide these and
        other features, and to operate the app and measure and improve its performance, as described
        in our <Link to="/terms-of-service">Terms of Service</Link>, <Link to="/privacy-policy">Privacy Policy</Link>,
        and <Link to="/consumer-health-data-policy">Consumer Health Data Policy</Link>.
      </p>

      <form onSubmit={handleSubmit}>
        <label style={{ display: 'block', margin: '1rem 0' }}>
          <input
            type="checkbox"
            checked={agreeTerms}
            onChange={(event) => setAgreeTerms(event.target.checked)}
          />{' '}
          I agree to Reaxano's Terms of Service, Privacy Policy, and Consumer Health Data Policy.
        </label>

        <label style={{ display: 'block', margin: '1rem 0' }}>
          <input
            type="checkbox"
            checked={agreeEmail}
            onChange={(event) => setAgreeEmail(event.target.checked)}
          />{' '}
          I agree to receive sponsored information about clinical trials and treatments relevant to my condition including by email.
        </label>

        <button type="submit" disabled={!agreeTerms}>
          Continue to account creation
        </button>
      </form>
    </main>
  );
}
